export default __webpack_public_path__ + "static/media/openSourceMobile.c366e432.png";